import { styled } from "styled-components";

// 아이콘은 24 x 24 그리드
export const Icon = styled.img`
  width: 24px;
  height: 24px;
`;
